import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Fade from '@mui/material/Fade';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';

const styles = theme => ({
  root: {
    position: 'absolute',
    top: theme.dimensions.md, // <--- Height of imageContainer header
    right: 0,
    left: 0,
    width: '100%',
    maxWidth: theme.dimensions.md,
    margin: '0 auto',
    padding: theme.spacing(2, 3),
    paddingBottom: theme.spacing(20),
  },
  rootDesktop: {
    maxWidth: theme.dimensions.lg,
  },
});

const WelcomeLowerContentWrapper = ({
  className,
  classes,
  children,
}) => {
  const isMobile = useMobileLayout();
  return (
    <Fade
      in
      timeout={{
        enter: 800,
      }}
    >
      <Box
        className={classNames(classes.root, { [classes.rootDesktop]: !isMobile }, className)}
      >
        {children}
      </Box>
    </Fade>
  );
};

WelcomeLowerContentWrapper.defaultProps = {
  className: '',
};

WelcomeLowerContentWrapper.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default withStyles(styles)(WelcomeLowerContentWrapper);
